<mat-card class="news-card">
    <mat-card-header class="news-header-bg">
        <mat-card-title>{{article.title}}</mat-card-title>
        <div *ngIf="loginService.activeUser.superAdmin" class="news-card-btn">
            <button
                    mat-button
                    matSuffix
                    mat-icon-button
                    (click)="edit()"
                    id="edit-news"
            >
                <mat-icon>edit</mat-icon>
            </button>
            <button
                    mat-button
                    matSuffix
                    mat-icon-button
                    (click)="delete()"
                    id="delete-news"
            >
                <mat-icon>clear</mat-icon>
            </button>
        </div>
    </mat-card-header>
    <mat-card-content>
        <p [innerHTML]="article.description | safeHtml"></p>
    </mat-card-content>
</mat-card>
